import { Header } from "@/components/SiteUI";
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import auth from "@/shared/api/auth"
import { Lock } from "lucide-react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"


export const ChangePasswordPage = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error("Пароли не совпадают");
        }

        if (password === "" || confirmPassword === "") {
            toast.error("Все поля обязательны");
        }

        try {
            const status = await auth.changePassword(password, confirmPassword);
            if (!status) {
                toast.error("Вы неверно ввели старый пароль");
                return;
            }
            toast.success("Пароль успешно изменен");
            navigate("/profile");
        } catch (err) {
            console.error(err.message);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-olive-50">
            <Header />
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle>Сброс пароля</CardTitle>
                    <CardDescription>Введите ваш новый пароль</CardDescription>
                </CardHeader>
                <CardContent>
                    <form className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="login-password">Новый пароль</Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                                <Input
                                    id="login-password"
                                    type="password"
                                    placeholder="••••••••"
                                    required
                                    className="pl-10"
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="login-password">Повторите пароль</Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                                <Input
                                    id="login-password"
                                    type="password"
                                    placeholder="••••••••"
                                    required
                                    className="pl-10"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    value={confirmPassword}
                                />
                            </div>
                        </div>

                        <Button onClick={handleSubmit} type="submit" className="w-full mt-2">
                            Сменить пароль
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}